import axios from 'axios'

let homeUrl = ''
if (process.env.NODE_ENV === 'production') {
    homeUrl = 'http://netemosametemo.jp/wp-json/wp/v2/'
    // homeUrl = 'http://netemosametemo.sugu-ticket.jp/wp-json/wp/v2/'
} else {
    // homeUrl = 'http://localhost:8888/wp-json/wp/v2/'
    homeUrl = 'http://netemosametemo.jp/wp-json/wp/v2/'
}

let commonAxios = axios.create({
    baseURL: homeUrl
})

export default commonAxios



// WEBPACK FOOTER //
// ./src/services/axios.js